import { api } from '@/api/client';
import { useQuery } from '@tanstack/react-query';
import type { ApprovalRequest } from '../types';

export function useApprovals(enabled = true) {
  const { data, isLoading, error, refetch } = useQuery<ApprovalRequest[], Error>({
    queryKey: ['approvals', 'pending'],
    queryFn: async () => {
      const res = await api.get<{ data: ApprovalRequest[] }>('/approvals/pending');
      return res.data;
    },
    refetchInterval: 30_000,
    staleTime: 25_000,
    enabled,
  });

  return { approvals: data ?? [], isLoading, error, refetch };
}
